export interface PlaatoMessage {
  timestamp: Date | string;
  kegWeight: number;
  weight: number;
  volume: number;
  temperature: number;
  isPouring: boolean;
  floodDetected: boolean;
}

export interface PlaatoDevice {
  deviceId: string;
  name?: string;
  lastUpdate?: Date;
}

export enum SignalRConnectionState {
  Disconnected = 'Disconnected',
  Connecting = 'Connecting',
  Connected = 'Connected',
  Reconnecting = 'Reconnecting',
  Error = 'Error'
}
